import { WindowCommand } from './window-command';

export class TulltaxanCommand extends WindowCommand {
  public url: string;

  public constructor(url: string) {
    super('tulltaxan');
    this.url = url;
  }

  public get data() {
    return {
      url: this.url
    };
  }
}
